package com.shreyasjoshi.components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.models.PortfolioData

@Composable
fun SkillsSection(isDarkMode: Boolean) {
    var searchQuery by remember { mutableStateOf("") }
    val categories = PortfolioData.skillCategories

    Section(
        attrs = {
            id("skills")
            classNames(
                "portfolio-section",
                "py-16", "px-4", "sm:px-6", "lg:px-8", "max-w-6xl", "mx-auto", "border-b", "transition-colors",
                if (isDarkMode) "border-white/10" else "border-slate-200"
            )
        }
    ) {
        Div(attrs = { classNames("space-y-10") }) {
            // Header & Search
            Div(attrs = { classNames("flex", "flex-col", "lg:flex-row", "lg:items-end", "justify-between", "gap-4") }) {
                Div(attrs = { classNames("space-y-2") }) {
                    Div(attrs = { classNames("text-xs", "font-mono", "text-[#189AD3]", "tracking-widest", "uppercase") }) {
                        Text("04 // SKILLS & DOMAIN PROFICIENCY")
                    }
                    H2(
                        attrs = {
                            classNames(
                                "text-3xl", "font-bold", "tracking-tight",
                                if (isDarkMode) "text-white" else "text-slate-900"
                            )
                        }
                    ) {
                        Text("Technical Ecosystem & Toolchain")
                    }
                }

                // Search Box
                Div(attrs = { classNames("w-full", "lg:w-72") }) {
                    Input(
                        type = org.jetbrains.compose.web.attributes.InputType.Text,
                        attrs = {
                            classNames(
                                "w-full", "px-3.5", "py-2", "rounded-sm", "border", "text-xs", "font-mono", "transition-colors",
                                if (isDarkMode) "bg-[#0a0a0a] border-white/10 text-white placeholder-white/40 focus:border-[#189AD3]"
                                else "bg-white border-slate-300 text-slate-900 placeholder-slate-400 focus:border-[#189AD3]"
                            )
                            attr("placeholder", "Filter skills (e.g., Kotlin, AOSP)...")
                            value(searchQuery)
                            onInput { e -> searchQuery = e.value }
                        }
                    )
                }
            }

            // Categories Grid
            Div(attrs = { classNames("grid", "grid-cols-1", "md:grid-cols-2", "lg:grid-cols-3", "gap-6") }) {
                categories.forEach { cat ->
                    val filteredSkills = cat.skills.filter {
                        searchQuery.isBlank() || it.name.contains(searchQuery, ignoreCase = true)
                    }

                    if (filteredSkills.isNotEmpty()) {
                        Div(
                            attrs = {
                                classNames(
                                    "p-6", "rounded-sm", "border", "flex", "flex-col", "justify-between", "transition-all",
                                    if (isDarkMode) "bg-[#0a0a0a] border-white/10" else "bg-slate-50 border-slate-200"
                                )
                            }
                        ) {
                            Div(attrs = { classNames("space-y-3") }) {
                                H3(
                                    attrs = {
                                        classNames(
                                            "text-base", "font-bold",
                                            if (isDarkMode) "text-white" else "text-slate-900"
                                        )
                                    }
                                ) {
                                    Text(cat.title)
                                }

                                P(
                                    attrs = {
                                        classNames(
                                            "text-xs", "leading-relaxed",
                                            if (isDarkMode) "text-white/50" else "text-slate-500"
                                        )
                                    }
                                ) {
                                    Text(cat.description)
                                }

                                // Skills Chips
                                Div(attrs = { classNames("flex", "flex-wrap", "gap-1.5", "pt-2") }) {
                                    filteredSkills.forEach { skill ->
                                        Span(
                                            attrs = {
                                                classNames(
                                                    "px-2.5", "py-1", "rounded-sm", "text-xs", "font-mono", "border", "transition-all",
                                                    if (skill.highlight) {
                                                        if (isDarkMode) "bg-[#189AD3]/10 text-[#71C7EC] border-[#189AD3]/40 font-semibold"
                                                        else "bg-sky-50 text-sky-800 border-sky-300 font-semibold"
                                                    } else {
                                                        if (isDarkMode) "bg-white/5 text-white/70 border-white/10"
                                                        else "bg-white text-slate-700 border-slate-200"
                                                    }
                                                )
                                            }
                                        ) {
                                            Text(skill.name)
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

